// frontend/src/lib/support/gwinBugSupport.js

import { supabase } from "../../supabaseClient";

const VALID_STATUSES = new Set([
  "open",
  "acknowledged",
  "resolved",
  "closed",
]);

function cleanText(
  value,
  maxLength
) {
  return String(
    value ?? ""
  )
    .trim()
    .slice(
      0,
      maxLength
    );
}

function cleanStatus(
  value
) {
  const status =
    cleanText(
      value,
      30
    ).toLowerCase();

  if (!status) {
    return null;
  }

  if (
    !VALID_STATUSES.has(
      status
    )
  ) {
    throw new Error(
      "Invalid bug report status."
    );
  }

  return status;
}

function cleanMetadata(
  value
) {
  if (
    !value ||
    typeof value !==
      "object" ||
    Array.isArray(value)
  ) {
    return {};
  }

  return value;
}

function normaliseBugReport(
  row
) {
  if (!row) {
    return null;
  }

  return {
    report_id:
      row.report_id || "",

    subject:
      row.subject || "",

    message:
      row.message || "",

    page_path:
      row.page_path || "",

    status:
      row.status || "open",

    created_at:
      row.created_at || null,

    acknowledged_at:
      row.acknowledged_at ||
      null,

    resolved_at:
      row.resolved_at ||
      null,

    closed_at:
      row.closed_at ||
      null,
  };
}

export async function createMyGwinBugReport({
  subject,
  message,
  pagePath = "",
  metadata = {},
}) {
  const cleanSubject =
    cleanText(
      subject,
      120
    );

  const cleanMessage =
    cleanText(
      message,
      4000
    );

  const cleanPagePath =
    cleanText(
      pagePath,
      500
    );

  if (
    cleanSubject.length <
    3
  ) {
    throw new Error(
      "Please enter a subject of at least 3 characters."
    );
  }

  if (
    cleanMessage.length <
    10
  ) {
    throw new Error(
      "Please provide a little more detail about the problem."
    );
  }

  const {
    data,
    error,
  } = await supabase.rpc(
    "create_my_gwin_bug_report",
    {
      p_subject:
        cleanSubject,

      p_message:
        cleanMessage,

      p_page_path:
        cleanPagePath ||
        null,

      p_metadata:
        cleanMetadata(
          metadata
        ),
    }
  );

  if (error) {
    throw error;
  }

  if (
    Array.isArray(data)
  ) {
    return data[0] || null;
  }

  return data || null;
}

export async function fetchMyGwinBugReports(
  status = null
) {
  const {
    data,
    error,
  } = await supabase.rpc(
    "get_my_gwin_bug_reports",
    {
      p_status:
        cleanStatus(
          status
        ),
    }
  );

  if (error) {
    throw error;
  }

  return (
    Array.isArray(data)
      ? data
      : []
  )
    .map(
      normaliseBugReport
    )
    .filter(Boolean);
}